<app-basic-page [pageTitle]="'My Account'">
  <div class="vertical-large">
    <div class="vertical">
      <h3>Current Workspace's Settings [{{ currentWorkspace().title }}]</h3>
      <div class="vertical-large">
        <div class="vertical basic-card-color purple-background full-width">
          <div class="vertical">
            <nz-avatar
              nzIcon="user"
              [nzSrc]="myPersonalBoard()?.userBoardConfig?.portraitUrl"
              [nzSize]="30"
            ></nz-avatar>
          </div>

          <div class="vertical">
            <div class="title">First Name</div>
            <input
              nz-input
              placeholder="First Name"
              nzSize="large"
              [(ngModel)]="myPersonalBoard()!.userBoardConfig!.preferredName"
            />
          </div>

          <div class="vertical">
            <div class="title">Last Name</div>
            <input
              nz-input
              placeholder="Last Name"
              nzSize="large"
              [(ngModel)]="myPersonalBoard()!.userBoardConfig!.lastName"
            />
          </div>

          <div class="horizontal">
            <button class="fit-content" nz-button nzType="default" nzSize="large" (click)="onSyncClick()">
              Sync with Account Profile
            </button>
            <button class="fit-content" nz-button nzType="primary" nzSize="large" (click)="onSaveClick()">Save</button>
          </div>
        </div>

        <div class="vertical basic-card-color geekblue-background full-width">
          <div class="title"><img style="width: 20px" src="/assets/images/logos/linkedin-1.png" /> LinkedIn</div>

          <div class="vertical-large">
            <button
              class="fit-content"
              [nzLoading]="isConnectedToUnipile() === undefined"
              nz-button
              nzType="default"
              nzSize="small"
              nz-popover
              nzPopoverTitle="Connect LinkedIn"
              [(nzPopoverVisible)]="isUnipileVisible"
              nzPopoverTrigger="click"
              [nzPopoverContent]="unipileContentTemplate"
            >
              @if (isConnectedToUnipile() === true) {
                <span nz-icon style="font-size: 24px" class="material-symbols-rounded">check</span>
                Connected
              } @else if (isConnectedToUnipile() === false) {
                Connect
              }

              <ng-template #unipileContentTemplate>
                <app-text-popup
                  [title]="'Account Id'"
                  [descriptionMarkdown]="connectUnipileDescriptionMarkdown"
                  (cancel)="onConnectUnipileCancel()"
                  (save)="onConnectUnipileClick($event)"
                ></app-text-popup>
              </ng-template>
            </button>

            @if (myPersonalBoard()?.userBoardConfig) {
              <div class="vertical">
                <div class="field-name">Invitation Chars Limit</div>

                <nz-input-number-group class="fit-content" nzAddOnAfter="chars">
                  <nz-input-number
                    [ngStyle]="{ width: '60px' }"
                    nzSize="large"
                    [(ngModel)]="myPersonalBoard()!.userBoardConfig!.linkedInMessageCharsLimit"
                    [nzStep]="1"
                  ></nz-input-number>
                </nz-input-number-group>
              </div>

              <div class="vertical">
                <div class="field-name">Invitation Message Instruction</div>

                <textarea
                  nz-input
                  placeholder="Invitation Message Instruction"
                  [nzAutosize]="{ minRows: 3, maxRows: 5 }"
                  [(ngModel)]="myPersonalBoard()!.userBoardConfig!.linkedInInvitationMessageInstruction"
                ></textarea>
              </div>

              <div class="vertical">
                <div class="field-name">Second Message Instruction</div>

                <textarea
                  nz-input
                  placeholder="Second Message Instruction"
                  [nzAutosize]="{ minRows: 3, maxRows: 5 }"
                  [(ngModel)]="myPersonalBoard()!.userBoardConfig!.linkedInSecondMessageInstruction"
                ></textarea>
              </div>

              <div class="vertical">
                <div class="field-name">Default Product</div>
                <nz-select
                  class="select"
                  [ngStyle]="{ width: '300px' }"
                  [nzSize]="'default'"
                  [(ngModel)]="myPersonalBoard()!.userBoardConfig!.linkedInMessageDefaultProductId"
                >
                  @for (item of productList(); track $index) {
                    <nz-option [nzValue]="item.id" [nzLabel]="item.title ?? ''"></nz-option>
                  }
                </nz-select>
              </div>

              <div class="vertical">
                <div class="field-name">Default Methodology</div>
                <nz-select
                  class="select"
                  [ngStyle]="{ width: '300px' }"
                  [nzSize]="'default'"
                  [(ngModel)]="myPersonalBoard()!.userBoardConfig!.linkedInMessageDefaultMethodologyId"
                >
                  @for (item of methodologyList(); track $index) {
                    <nz-option [nzValue]="item.id" [nzLabel]="item.title ?? ''"></nz-option>
                  }
                </nz-select>
              </div>

              <div class="vertical">
                <div class="field-name">Default Goal</div>
                <nz-select
                  class="select"
                  [ngStyle]="{ width: '300px' }"
                  [nzSize]="'default'"
                  [(ngModel)]="myPersonalBoard()!.userBoardConfig!.linkedInMessageDefaultGoalId"
                >
                  @for (item of goalList(); track $index) {
                    <nz-option [nzValue]="item.id" [nzLabel]="item.title"></nz-option>
                  }
                </nz-select>
              </div>

              <div class="vertical">
                <div class="field-name">Default Slack Channel Id</div>
                <input
                  nz-input
                  placeholder="Default Slack Channel Id"
                  [(ngModel)]="myPersonalBoard()!.userBoardConfig!.linkedInSlackChannelId"
                />
              </div>

              <div class="vertical">
                <div class="field-name">Accept Connection Slack Channel Id</div>
                <input
                  nz-input
                  placeholder="Accept Connection Slack Channel Id"
                  [(ngModel)]="myPersonalBoard()!.userBoardConfig!.linkedInAcceptConnectionSlackChannelId"
                />
              </div>

              <div class="vertical">
                <div class="field-name">Respond Slack Channel Id</div>
                <input
                  nz-input
                  placeholder="Respond Slack Channel Id"
                  [(ngModel)]="myPersonalBoard()!.userBoardConfig!.linkedInRespondSlackChannelId"
                />
              </div>
            }

            <div class="horizontal">
              <button class="fit-content" nz-button nzType="primary" nzSize="large" (click)="onSaveClick()">
                Save
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="vertical">
      <h3>Account Profile [Global]</h3>
      <div #userProfile></div>
    </div>
  </div>
</app-basic-page>
